import './oiTimeline.css';
import React, { Component } from 'react';

import axios from 'axios';
import History from '../../History';
import FaFrownO from 'react-icons/lib/fa/frown-o';
import FaSearchIcon from 'react-icons/lib/fa/search';

import OiMenu from '../oiMenu/oiMenu';
import OiModal from '../oiModal/oiModal';
import OiButton from '../oiButton/oiButton';
import OiLoading from '../oiLoading/oiLoading';
import OiSearchBar from '../oiSearchBar/oiSearchBar';
import OiHeaderLite from '../oiHeaderLite/oiHeaderLite';
import OiHeaderFull from '../oiHeaderFull/oiHeaderFull';
import OiSingleNews from '../oiSingleNews/oiSingleNews';

class oiTimeline extends Component {
    state = {
        searchTerm: '',
        currentPage: 1,
        isLoading: true,
        listOfNews: [],
        numOfPages: null,
        menuIsOpen: false,
        searchFlag: false,
        modalIsOpen: false,
        timelineFlag: true,
        btnIsDisabled: false,
        listOfCategories: [],
        selectedCategory: '',
        urlParams: this.props.location.search,
        msisdn: sessionStorage.getItem('msisdn'),
        isBundle: sessionStorage.getItem('isBundle'),
        isBundleAccept: sessionStorage.getItem('isBundleAccept'),
        phoneNumber: sessionStorage.getItem('phoneNumber'),
        modal: {
            title: null,
            text: null,
            btn1: null,
            btn2: null,
            event1: null,
            event2: null
        }
    };

    componentWillMount = () => {
        if (this.state.urlParams) {
            let aux = this.state.urlParams;
            let msisdn = '';
            let phoneNumber = '';
            let sessionToken = '';

            aux = aux.split('&');
            msisdn = aux[0].split('=')[1];
            phoneNumber = aux[1].split('=')[1].replace('%20', ' ');
            sessionToken = aux[2].split('=')[1];

            sessionStorage.setItem('msisdn', msisdn);
            sessionStorage.setItem('phoneNumber', phoneNumber);
            sessionStorage.setItem('sessionToken', sessionToken);
        }
    }

    componentDidMount = () => {
        sessionStorage.removeItem('searchTerm');

        if (!sessionStorage.getItem("msisdn") || !sessionStorage.getItem("sessionToken")) {
            History.push(`${process.env.PUBLIC_URL}/`);
        }

        if (sessionStorage.getItem('isBundle') === 'yes') {
            if (!sessionStorage.getItem('userData')) {
                this.getUserData(() => {
                    this.getListOfNews(this.state.currentPage);
                });
            }
            else {
                this.getListOfNews(this.state.currentPage);
                setTimeout(() => { this.refreshToken() }, (10 * 60 * 1000));
            }
        }
        else {
            if (!sessionStorage.getItem('userData')) {
                this.getCategories(false, () => {
                    this.getUserData(() => {
                        this.getListOfNews(this.state.currentPage, this.state.selectedCategory);
                    });
                });
            }
            else {
                this.getCategories(false, () => {
                    this.getListOfNews(this.state.currentPage, this.state.selectedCategory);
                    setTimeout(() => { this.refreshToken() }, (10 * 60 * 1000));
                });
            }
        }
    }

    manageModalWithCallback = (callback) => {
        this.setState({ modalIsOpen: !this.state.modalIsOpen });

        callback();
    }

    menuToogleHandler = () => {
        this.setState({ menuIsOpen: !this.state.menuIsOpen });
    }

    goToNewsHandler = (event) => {
        this.setState({ isLoading: true });
        let newsId = event.target.attributes.getNamedItem('data-id').value;

        History.push(`${process.env.PUBLIC_URL}/noticia?id=` + newsId);
    }

    loadMoreNews = (isFromMoreFlux) => {
        let currentPage = this.state.currentPage + 1;

        this.setState({
            btnIsDisabled: true,
            currentPage: currentPage
        }, () => {
            this.getListOfNews(currentPage, this.state.selectedCategory, isFromMoreFlux);
        });
    }

    refreshToken = () => {
        //API REFRESH TOKEN
        let self = this;
        let url = 'https://api.oston.io/clicnoticia/v1/auth/token/refresh';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
            }
        };

        axios.post(url, {}, config)
            .then(refresh => {
                sessionStorage.setItem('sessionToken', refresh.data.token);
                setTimeout(() => { self.refreshToken() }, (10 * 60 * 1000));
            })
            .catch(error => {
                sessionStorage.removeItem('sessionToken');

                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Sua sessão expirou. Por favor, faça login novamente.',
                        btn1: 'Ir para o login',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/`);
                            })
                        }
                    }
                });
            });
    }

    getCategories = (isChoosen, callback) => {
        //API GET CATEGORIES
        let self = this;
        let url = sessionStorage.getItem('isBundle') === "yes" ?
            'https://api.oston.io/clicnews-lite/v1/news/categories'
            :
            'https://api.oston.io/clicnoticia/v2/news/categories';
        const config = {
            headers: {
                'Accept': 'application/json'
            }
        };

        console.log(sessionStorage.getItem('isBundle'));

        axios.get(url, config)
            .then(response => {
                let newArray = [];
                let listOfCategories = response.data.data;
                let userData = JSON.parse(sessionStorage.getItem('userData'));

                newArray = (
                    <React.Fragment>
                        {
                            listOfCategories.map((category, index) => {
                                if (category.slug === 'destaques') {
                                    return (
                                        <li key={category.slug + index}
                                            className={self.isActive(category.slug)}
                                            onClick={(event) => { self.chooseCategoryNews(event) }}>
                                            Timeline </li>
                                    );
                                }
                                else if (category.slug === 'seu-dinheiro' && sessionStorage.getItem('isBundle') === "no") {
                                    return (
                                        <li key={category.slug + index}
                                            className={self.isActive('seu dinheiro')}
                                            onClick={(event) => { self.chooseCategoryNews(event) }}>
                                            Seu Dinheiro </li>
                                    );
                                }
                                else if (category.slug === 'tv-e-fama') {
                                    return (
                                        <li key={category.slug + index}
                                            className={self.isActive('tv e fama')}
                                            onClick={(event) => { self.chooseCategoryNews(event) }}>
                                            TV e Fama </li>
                                    );
                                }

                                return (<li key={category.slug + index} className={self.isActive(category.slug)} onClick={(event) => { self.chooseCategoryNews(event) }}>{category.name}</li>);
                            })
                        }
                    </React.Fragment>
                );

                if (isChoosen) {
                    self.setState({ listOfCategories: newArray });
                }
                else {
                    self.setState({
                        listOfCategories: newArray,
                        selectedCategory: userData && userData.data !== null ? userData.data.interests : History.push(`${process.env.PUBLIC_URL}/interesses`)
                    });
                }

                if (callback) {
                    callback();
                }

            })
            .catch(error => {
                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao buscar as categorias. Por favor, recarregue a página.',
                        btn1: 'Recarregar',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/noticias`);
                                window.location.reload();
                            })
                        }
                    }
                });
            });
    }

    getUserData = (callback) => {
        //API GET PROFILE
        let self = this;
        let url = 'https://api.oston.io/clicnoticia/v1/profile';
        const config = {
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('sessionToken')
            }
        };

        axios.get(url, config)
            .then(userData => {
                if (userData.data.user.data !== null) {
                    if (userData.data.user.data.interests.length > 0) {
                        sessionStorage.setItem('userData', JSON.stringify(userData.data.user));

                        self.setState({
                            selectedCategory: userData.data.user.data.interests
                        });

                        if (callback) {
                            callback();
                        }
                    }
                    else {
                        sessionStorage.setItem('userData', JSON.stringify(userData.data.user));
                        History.push(`${process.env.PUBLIC_URL}/interesses`);
                    }
                }
                else {
                    sessionStorage.setItem('userData', JSON.stringify(userData.data.user));
                    History.push(`${process.env.PUBLIC_URL}/interesses`);
                }
            })
            .catch(error => {
                sessionStorage.removeItem('sessionToken');

                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao buscar os dados do usuário. Por favor, faça login novamente.',
                        btn1: 'Ir para o login',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/`);
                            })
                        }
                    }
                });
            });
    }

    getListOfNews = (currentPage, heritageCategories, isFromMoreFlux) => {
        //API GET LIST OF NEWS
        let url = '';
        let self = this;
        let categories = '';
        let userData = JSON.parse(sessionStorage.getItem('userData'));

        if (userData.data === null) {
            categories = 'destaques';
        }
        else {
            categories = 'destaques&subcategories=' + userData.data.interests.toString();
        }

        if (sessionStorage.getItem('isBundle') === 'no') {
            if (heritageCategories) {
                let newCategories = JSON.stringify(heritageCategories);
                let hasMyMoney = newCategories.search("seu dinheiro");
                let hasTvEFama = newCategories.search("tv e fama");

                if (hasMyMoney !== -1) {
                    newCategories = newCategories.replace("seu dinheiro", "seu-dinheiro");
                }
                else if (hasTvEFama !== -1) {
                    newCategories = newCategories.replace("tv e fama", "tv-e-fama");
                }

                categories = JSON.parse(newCategories.trim());
            }
        }

        if (this.state.searchTerm.length > 0) {
            url = sessionStorage.getItem('isBundle') === "yes" ?
                'https://api.oston.io/clicnews-lite/v1/news?page=' + currentPage + '&searchTerm=' + this.state.searchTerm
                :
                'https://api.oston.io/clicnoticia/v2/news?page=' + currentPage + '&searchTerm=' + this.state.searchTerm;
        }
        else {
            url = sessionStorage.getItem('isBundle') === "yes" ?
                'https://api.oston.io/clicnews-lite/v1/news?categories=' + categories + '&page=' + currentPage
                :
                'https://api.oston.io/clicnoticia/v2/news?categories=' + categories + '&page=' + currentPage;

        }

        const config = {
            headers: {
                'Accept': 'application/json'
            }
        };

        axios.get(url, config)
            .then(response => {
                let newsElements = (
                    <div id={"page-" + currentPage} key={currentPage}>
                        {
                            response.data.data.map((item) => {
                                let channel = 'Destaque';

                                if (item.subtitle) {
                                    item.subtitle = item.subtitle.replace(new RegExp('<p>', ''), '');
                                    item.subtitle = item.subtitle.replace(new RegExp('</p>', ''), '');
                                    item.subtitle = item.subtitle.replace(new RegExp('&nbsp;', 'g'), '');
                                    item.subtitle = item.subtitle.replace(new RegExp('&lt;', 'g'), '<');
                                    item.subtitle = item.subtitle.replace(new RegExp('&gt;', 'g'), '>');
                                    item.subtitle = item.subtitle.replace(new RegExp('&amp;', 'g'), '&');
                                    item.subtitle = item.subtitle.replace(new RegExp('&quot;', 'g'), '"');
                                    item.subtitle = item.subtitle.replace(new RegExp('&apos;', 'g'), "'");
                                }

                                if (item.preview) {
                                    item.preview = item.preview.replace(new RegExp('<p>', ''), '');
                                    item.preview = item.preview.replace(new RegExp('</p>', ''), '');
                                    item.preview = item.preview.replace(new RegExp('&nbsp;', 'g'), '');
                                    item.preview = item.preview.replace(new RegExp('&lt;', 'g'), '<');
                                    item.preview = item.preview.replace(new RegExp('&gt;', 'g'), '>');
                                    item.preview = item.preview.replace(new RegExp('&amp;', 'g'), '&');
                                    item.preview = item.preview.replace(new RegExp('&quot;', 'g'), '"');
                                    item.preview = item.preview.replace(new RegExp('&apos;', 'g'), "'");

                                }

                                if (item.channel.data.length !== 0) {
                                    channel = item.channel.data[0].name;
                                }

                                if (item.image) {
                                    return (
                                        <OiSingleNews
                                            id={item.id}
                                            key={item.id}
                                            text={item.subtitle ? item.subtitle : item.preview}
                                            channel={channel}
                                            title={item.title}
                                            humanDate={item.human_date}
                                            image={'http://api.oston.io/images/publizee/' + item.image}
                                            clickEvent={(event) => { self.goToNewsHandler(event) }}
                                        />);
                                }
                                else {
                                    return (
                                        <OiSingleNews
                                            image={null}
                                            id={item.id}
                                            key={item.id}
                                            text={item.subtitle ? item.subtitle : item.preview}
                                            channel={channel}
                                            title={item.title}
                                            humanDate={item.human_date}
                                            clickEvent={(event) => { self.goToNewsHandler(event) }}
                                        />);

                                }
                            })
                        }
                    </div>
                );

                let newArray = [];
                if ((sessionStorage.getItem('isBundle') === 'yes' && isFromMoreFlux) || (sessionStorage.getItem('isBundle') === 'no' && isFromMoreFlux)) {
                    newArray = [...self.state.listOfNews];
                    newArray.push(newsElements);
                }
                else if (self.state.searchTerm.length > 0) {
                    newArray.push(newsElements);
                }
                else if ((sessionStorage.getItem('isBundle') === 'no' && !isFromMoreFlux)) {
                    if (response.data.data.length > 0) {
                        newArray.push(newsElements);
                    }
                    else {
                        self.setState({ selectedCategory: 'destaques' }, () => {
                            self.getListOfNews(self.state.currentPage, 'destaques', false);
                        });
                    }
                }
                else {
                    newArray = [...self.state.listOfNews];
                    newArray.push(newsElements);
                }

                self.setState({
                    isLoading: false,
                    btnIsDisabled: false,
                    listOfNews: newArray,
                    numOfPages: response.data.meta.pagination.total_pages
                }, () => {
                    if (currentPage > 1) {
                        document.getElementById('page-' + currentPage).scrollIntoView(
                            {
                                behavior: 'smooth',
                                block: "start"
                            }
                        );
                    }
                }
                );
            })
            .catch(error => {
                self.setState({
                    modalIsOpen: true,
                    isLoading: false,
                    modal: {
                        title: 'Atenção',
                        text: 'Falha ao carregar as notícias. Por favor, recarregue a página.',
                        btn1: 'Recarregar',
                        event1: () => {
                            self.manageModalWithCallback(() => {
                                History.push(`${process.env.PUBLIC_URL}/noticias`);
                                window.location.reload();
                            })
                        }
                    }
                });
            });
    }

    searchHandler = (event) => {
        event.preventDefault();

        this.setState({ isLoading: true, currentPage: 1, searchFlag: false }, () => {
            sessionStorage.setItem('searchTerm', this.state.searchTerm);
            this.getListOfNews(this.state.currentPage);
        });
    }

    getSearchValue = (event) => {
        let inputValue = event.target.value.trim();
        this.setState({ searchTerm: inputValue });
    }

    formatText = (text) => {
        text = text.toLowerCase();
        text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
        text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
        text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
        text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
        text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
        text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
        return text;
    }

    chooseCategoryNews = (event) => {
        let timelineControl = false;
        let userData = JSON.parse(sessionStorage.getItem('userData'));
        let categoryName = this.formatText(event.target.textContent).trim();

        if (categoryName === 'timeline') {
            categoryName = userData && userData.data !== null ? userData.data.interests : 'destaques';
            timelineControl = true;
        }

        this.setState(
            {
                searchTerm: '',
                currentPage: 1,
                isLoading: true,
                searchFlag: false,
                timelineFlag: timelineControl,
                selectedCategory: categoryName
            }, () => {
                this.getCategories(true, () => {
                    sessionStorage.removeItem('searchTerm');
                    this.getListOfNews(this.state.currentPage, categoryName);
                });
            });
    }

    isBundleAccept = (event) => {
        this.setState({ isBundleAccept: "yes" });
        sessionStorage.setItem("isBundleAccept", "yes");
    }

    isActive = (value) => {
        let newValue = this.formatText(value).trim();

        if (this.state.timelineFlag) {
            this.setState({ timelineFlag: false })
            return 'active-li';
        }

        return (newValue === this.state.selectedCategory ? 'active-li' : '');
    }

    render = () => {
        let ShowModalInformation = '';
        let Menu = '';
        let results = '';
        let renderPage = '';

        if (this.state.listOfNews[0] !== undefined && sessionStorage.getItem('searchTerm')) {
            if (this.state.listOfNews[0].props.children.length > 0) {
                results = (
                    <div id="results-box">
                        <h2>
                            Resultados para <u>{decodeURIComponent(sessionStorage.getItem('searchTerm'))}</u>:
                        </h2>
                    </div>
                );
            }
            else {
                results = (
                    <div id="no-data-box">
                        <p>Não há resultados para <u>{decodeURIComponent(sessionStorage.getItem('searchTerm'))}</u>.</p>
                        <FaFrownO id="no-data-icon" />
                    </div>
                );
            }
        }

        if (this.state.isBundle === 'yes') {

            if (!this.state.isBundleAccept) {

                const Modal = {
                    title: "Bem-vindo ao Clic News!",
                    text: "Acesse sem custo adicional e mantenha-se informado sobre as principais notícias do Brasil e do mundo!",
                    event1: () => { this.isBundleAccept() },
                    btn1: "ok"
                };

                ShowModalInformation = (
                    <OiModal
                        modal={Modal}
                    // modalTitle={'Usuário Bundle'}
                    // modalText={'O seu serviço só sera gratuito no seu primeiro acesso.'}
                    // modalEvent1={this.isBundleAccept()}
                    />
                )
            }

            if (this.state.menuIsOpen) {
                Menu = (
                    <OiMenu
                        widthMenu={'75%'}
                        widthLayer={'100%'}
                        widthContainer={'100vw'}
                        phoneNumber={this.state.phoneNumber}
                        clickEvent={() => { this.menuToogleHandler() }}
                    />
                );
            }
            else {
                Menu = (
                    <OiMenu
                        widthMenu={'0'}
                        widthLayer={'0'}
                        widthContainer={'0'}
                        phoneNumber={this.state.phoneNumber}
                        clickEvent={() => { this.menuToogleHandler() }}
                    />
                );
            }

            renderPage = (
                <React.Fragment>

                    {ShowModalInformation}

                    <OiHeaderLite
                        isBundle={true}
                        clickEvent={() => { this.menuToogleHandler() }}
                    />

                    <OiSearchBar
                        layerEvent={() => { this.setState({ searchFlag: true }) }}
                        clickEvent={(event) => { this.searchHandler(event) }}
                        changeEvent={(event) => { this.getSearchValue(event) }}
                    />

                    {results}
                    {this.state.listOfNews}

                    {
                        ((this.state.listOfNews.length > 0) && (this.state.currentPage !== this.state.numOfPages)) ?
                            <div id="oi-timeline-load-space">
                                <OiButton
                                    value="carregar mais" isDisabled={this.state.btnIsDisabled}
                                    clickEvent={() => { this.loadMoreNews(true) }}
                                />
                            </div> : ''
                    }

                </React.Fragment>
            );
        }
        else {
            renderPage = (
                <React.Fragment>
                    <OiHeaderFull avatarImage={JSON.parse(sessionStorage.getItem('userData')) ? JSON.parse(sessionStorage.getItem('userData')).avatar : null}>
                        <ul id="oi-header-full-categories">
                            <li onClick={() => {
                                this.setState({ searchFlag: !this.state.searchFlag });
                            }}>
                                <FaSearchIcon
                                    id="oi-search-bar-icon-full"
                                />
                                Busca</li>

                            {this.state.listOfCategories}
                        </ul>
                    </OiHeaderFull>

                    {this.state.searchFlag ?
                        <OiSearchBar
                            isFull={true}
                            clickEvent={(event) => { this.searchHandler(event) }}
                            changeEvent={(event) => { this.getSearchValue(event) }}
                        />
                        : ''}

                    {results}
                    {this.state.listOfNews}

                    {
                        ((this.state.listOfNews.length > 0) && (this.state.currentPage !== this.state.numOfPages)) ?
                            <div id="oi-timeline-load-space">
                                <OiButton
                                    value="carregar mais" isDisabled={this.state.btnIsDisabled}
                                    clickEvent={() => { this.loadMoreNews(true) }}
                                />
                            </div> : ''
                    }
                </React.Fragment>
            );
        }

        return (
            <div id="oi-timeline">
                {this.state.isLoading && this.state.listOfNews ? <OiLoading /> : ''}
                {this.state.modalIsOpen ? <OiModal modal={this.state.modal} /> : ''}
                {this.state.isBundle === 'yes' ? Menu : ''}
                {this.state.searchFlag === true ? <div id="search-layer" onClick={() => { this.setState({ searchFlag: false }) }}></div> : ''}

                {renderPage}
            </div>
        );
    }
};

export default oiTimeline;


// WEBPACK FOOTER //
// ./src/components/oiTimeline/oiTimeline.js